var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM12.0713 8.45809C12.3329 8.1998 12.3319 7.78111 12.0676 7.52158L8.92183 4.43226C8.41886 3.93033 7.66466 4.68295 8.16763 5.18488L10.2699 7.28096C10.3734 7.38413 10.337 7.46777 10.1903 7.46777L4.39025 7.46777C4.09497 7.46777 3.8556 7.70403 3.8556 8.00004C3.8556 8.29401 4.09446 8.53231 4.39025 8.53231H10.1903C10.3377 8.53231 10.373 8.61627 10.2699 8.71913L8.16763 10.8152C7.66466 11.3169 8.41886 12.0698 8.92183 11.5678L12.0713 8.45809Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.4405abc52128c2170c368309a3d6acc6.svg";
export { ForwardRef as ReactComponent };